<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item class='mb15' label="关键字" name='keyword'>
      <a-input v-model:value="search.keyword" :style="{width:'330px'}" placeholder="请输入门店编号/名称/手机号码/负责人进行搜索" />
    </a-form-item>
    <a-form-item label="门店类型" name='type_id' v-if="!level_id&&!type_id">
      <a-select v-model:value="search.type_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
        </a-select-option>
      </a-select>
      <a-select class="m-l-20" v-model:value="search.level_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click='select(0)' :hidden='hiddenHead' >选择总部</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' v-if='!checkout' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getPublicLevelList, getPublicTypeList, getStoreList } from "@/api/store";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: "",
    level_id: '',
    type_id: '',
    page: 1,
    limit:5,
    status: 1,
    dealer_id:''
  };
  export default {
    name: "selectStore",
    components: {},
    props: {
      dealer_id: {
        type: Number || String
      },
      selectList:{
        type:Array
      },
      checkout:{
        type:Boolean
      },
      hiddenHead:{
        type:Boolean
      },
      type_id:{
        type:String,
      },
      level:{
        type:String
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        typeList: [],
        total: 1,
        levelList: [],
        selectList:[],
        checkout:false
      });
      let columns = [
        {
          title: "门店编号",
          dataIndex: "store_code",
          key: "store_code",
        },
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
        },
        {
          title: "门店类型",
          dataIndex: "type_name",
          key: "type_name",
        },
        {
          title: "负责人",
          dataIndex: "clerk_name",
          key: "clerk_name",
        },
        {
          title: "手机号码",
          dataIndex: "clerk_phone",
          key: "clerk_phone",
        },
        {
          title: "操作",
          key: "action",
          width:120,
          slots: { customRender: "action" }
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        if(e!=0){
        e.select = !e.select
        }
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.id == e.id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () =>{ 
        emit("select",state.selectList);
      }
      // 获取类型列表
      const getType = async () => {
        let res = await getPublicTypeList().then(res => res.data);
        if (iscode(res)) {
          state.typeList = res.data.data;
        } else {
          message.error(res.msg);
        }
      }
      //获取等级列表
      const getLvevl = async () => {
        let res = await getPublicLevelList().then(res => res.data);
        if (iscode(res)) {
          state.levelList = res.data.data;
        } else {
          message.error(res.msg);
        } 
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          var type_id=props.type_id || values.type_id
          let res = await getStoreList({...values,dealer_id:props.dealer_id,type_id}).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
            if(props.checkout){
              state.checkout = props.checkout
            }
            if(state.selectList || state.selectList.length > 0){
              data.value.forEach(i=>{
                if( state.selectList.find(v=>{
                  return i.id == v.id || i.id==v.store_id
                })){
                  i.select=true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };

      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        
        getType();
        getLvevl();
        initData(search.value)
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm,
      };
    },
  };
</script>